// extracted by mini-css-extract-plugin
module.exports = {"container":"react-hooks_container__1xAsQ"};